import { writable } from "svelte/store";
import { millisecondsFromHours, startOfDay } from "../helpers/time.js";
import persisted from "./common/persisted.js";
import semaphore from "./semaphore.js";

export function dayNumber(chronology) {
    const today = startOfDay(new Date());
    const start = startOfDay(new Date(chronology.startedAt));

    return (
        Math.round(
            (today.getTime() - start.getTime()) / millisecondsFromHours(24)
        ) + 1
    );
}

function createChronologyStore() {
    const { subscribe, set, update } = writable({
        startedAt: Date.now(),
        duration: 0,
        totalDuration: 0
    });

    let interval;
    let isSemaphorePaused = false;

    function resume(rate = 1.0) {
        if (interval !== undefined) {
            return;
        }

        let lastUpdatedAt;

        function tick() {
            if (lastUpdatedAt === undefined) {
                lastUpdatedAt = Date.now();
            }

            update((state) => {
                let delta = Date.now() - lastUpdatedAt;

                if (isSemaphorePaused) {
                    delta = 0.0;
                }

                return {
                    ...state,
                    duration: (state.duration || 0) + delta * rate,
                    totalDuration: (state.totalDuration || 0) + delta,
                    note: undefined
                };
            });

            lastUpdatedAt = Date.now();
        }

        clearInterval(interval);
        interval = setInterval(tick, 1000 / 60);
    }

    function reset() {
        update((state) => ({ ...state, duration: 0 }));
    }

    semaphore.subscribe(({ isPaused }) => {
        isSemaphorePaused = isPaused;
    });

    return {
        subscribe,
        resume,
        reset,
        set
    };
}

const chronology = persisted("chronology:v5", true, createChronologyStore());

export default chronology;
